import { connect } from 'react-redux';

import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import CheckoutDialogButton from '../components/checkout-button';

const mapStateToProps = (state: BucketState) => {
  const { section } = state.repository.source;
  const refName = section.ref ? section.ref.name : null;
  return {
    repository: getCurrentRepository(state),
    refName,
    hash: state.repository.source.section.hash,
  };
};

export default connect(mapStateToProps)(CheckoutDialogButton);
